'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './service-requests-edit.routes';

export class ServiceRequestsEditComponent {

  constructor(IntegrationService, Auth, dialogs, $state, Config) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.Auth = Auth;
    this.dialogs = dialogs;
    this.$state = $state;
    this.integrationAvailable = true;
    this.IntegrationService = IntegrationService;

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, "Service Request");

    this.configMS = Config.getPlatformConfig().getManagementSuiteIntegratonSettings();

    if (!this.configMS || !this.configMS.clientCode) {
      this.integrationAvailable = false;
    }

    Auth.getCurrentUser(user => {
      let fullName = user.firstName;
      if (user.middleName)
        fullName += " " + user.middleName;
      fullName += " " + user.lastName;

      this.model = {
        requester: {
          email: user.email,
          fullName: fullName,
          firstName: user.firstName,
          middleName: user.middleName,
          lastName: user.lastName,
          communityCode: this.configMS.clientCode,
          webaccess: user.webaccessId
        },
        chat: [{
          note: "",
          firstName: user.firstName,
          middleName: user.middleName,
          lastName: user.lastName,
          meta: {
            webaccessUser: user.webaccessId
          }
        }]
      };
    });

    IntegrationService.test(result => {
      if (!result || !result.status || !result.status == 'successful') {
        this.integrationAvailable = false;
      } else {

        IntegrationService.queryProperties(properties => {

          this.properties = properties.map(ppty => {
            ppty.name = ppty.propertyAddress + " / Lot# " + ppty.lotNo;
            return ppty;
          });

          //TODO: make service request for community possible; but multiple communities per webaccess possible
          /*
          this.properties.unshift({
            propertyId: null,
            name: "Common Area"
          });*/

        }, _=> {
        });

        IntegrationService.queryServiceRequestCodes(data => {
          this.codes = data.filter(code => code.published);
          this.codesEnum = this.codes.map(code => { return {code: code.code, name: code.name} });
        });

      }
    })
  }

  codeChanged () {
    let oCode = this.codes.find(code => code.code == this.model.code);

    if (!oCode)
      return;

    this.model.sequence = oCode.sequence;
    this.model.name = oCode.name;
    this.model.description = oCode.description;
    this.model.instructions = oCode.instructions;
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = () => {
        var dlg = this.dialogs.notify("Success", "The service request ticket has been created successfully");
        dlg.result.then(() => {
          that.$state.go("service-requests-list");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      this.IntegrationService.saveServiceRequest(this.model, onSuccess, onError);
    }
  }
}

export default angular.module('conduuApp.serviceRequests.edit', [uiRouter])
  .config(routes)
  .component('serviceRequestsEdit', {
    template: require('./service-requests-edit.html'),
    controller: ServiceRequestsEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/service-requests/edit/service-requests-edit.component.js